import { useMutation } from '@tanstack/react-query';
import { isAxiosError } from 'axios';
import { createReport } from '@api-client/api-client';
import type { ReportContentType } from '@models/api';
import { toast } from '@hooks/use-toast';
import { logger } from '@utils/logger';

export const useReport = () => {
  return useMutation({
    mutationFn: ({
      contentType,
      contentId,
      reasons,
      details,
    }: {
      contentType: ReportContentType;
      contentId: string;
      reasons: string[];
      details: string | null;
    }) =>
      createReport({
        content_type: contentType,
        content_id: contentId,
        reasons,
        details,
      }),
    onSuccess: () => {
      toast({ title: 'Report submitted', description: 'Thank you for your feedback.' });
    },
    onError: error => {
      if (isAxiosError(error) && error.response?.status === 409) {
        toast({
          title: 'Already reported',
          description: 'You have already reported this content.',
        });
        return;
      }
      logger.error('Failed to submit report:', error);
      toast({
        title: 'Failed to submit report',
        description: 'Please try again.',
        variant: 'error',
      });
    },
  });
};
